import fitmentSearch from './fitmentSearch.js';
import specifyVehicle from './specifyVehicle.js';
import klaviyo from './klaviyo.js';

export default [fitmentSearch, specifyVehicle, klaviyo];
